import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import OlinAmanahConfirm from "../../components/screen/purchaseOnline/OlinAmanahConfirm";

const ActivateOlinAmanahConfirmPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <OlinAmanahConfirm />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gradient-blue-amanah"}
    />
  );
};

export default HOC(ActivateOlinAmanahConfirmPage);
